import React, { useEffect, useState } from 'react'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'
import PageHeading from '../../components/pageHeading/PageHeading'
import { Button } from 'react-bootstrap'
import './deliveryStatus.scss'
import LogOut from '../../modals/logout/LogOut'
import { useDispatch, useSelector } from 'react-redux';
import { jobId, setLoader  } from '../../slice/commonSlice'
import { fetchJobDetails, fetchLatLang } from '../../services/auth.service'
import moment from 'moment'
import LiveTracking from './LiveTracking'
import { GOOGLE_MAPS_API_KEY } from '../../config/Constant'
import { useJsApiLoader } from '@react-google-maps/api';

const JobStatus = () => {
    const dispatch = useDispatch();
    const [details, setDetails] = useState({});
    const [jobDetails, setJobDetails] = useState({});
    const [origin, setOrigin] = useState(null);
    const [destination, setDestination] = useState(null);
    const libraries = ['places'];

    let id = useSelector(jobId);

    useEffect(() => {
        if (id) {
            fetchJob()
        }
    }, [id])

    const fetchJob = async () => {
        let payload = {
            "id": id
        }
        await dispatch(setLoader(true));
        try {
            const response = await fetchJobDetails(payload);
            await dispatch(setLoader(false));
            let [job] = response.data?.jobData;
            setDetails(response.data);
            setJobDetails(job);
        } catch (error) {
            await dispatch(setLoader(false));
            console.error("Error fetching data:", error);
        }
    }
    const formatDateTime = (date) => {
        if (date) {
          const inputDate = moment.utc(date).tz('Atlantic/Bermuda');
          const formattedDate = inputDate.format('h:mm A, DD MMMM YYYY');
          return formattedDate;
        } else {
          return '';
        }
      };
      
    const handleGeocode = (address, setCoordinates) => {
        if (isLoaded) {
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ address }, (results, status) => {
            if (status === 'OK' && results.length > 0) {
              const { lat, lng } = results[0].geometry.location;
            //   console.log('>>>>>', lat(), lng())
              setCoordinates({ lat: lat(), lng: lng() });
            } else {
              console.error('Geocoding failed:', status);
            }
          });
        } else {
          console.error('Google Maps API is not loaded.');
        }
      };
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
        libraries
      });
   
      useEffect(()=>{
        if(isLoaded && jobDetails?.sender?.address && jobDetails?.receiver?.address){
            if(jobDetails?.sender?.address){
                handleGeocode(jobDetails?.sender?.address, setOrigin)
            }
            if(jobDetails?.receiver?.address){
                handleGeocode(jobDetails?.receiver?.address, setDestination)
            }
        }
      },[isLoaded, jobDetails?.sender?.address, jobDetails?.receiver?.address])
    
    const checkDisabled = (opt, status) => {
        if (opt === 'otw' && (status === 'otw' || status === 'inTransit' || status === 'delivered')) {
            return true
        } else if (opt === 'inTransit' && (status === '' || status === 'inTransit' || status === 'delivered')) {
            return true
        } else if (opt === 'delivered' && (status === '' || status === 'otw' || status === 'delivered')) {
            return true
        }
    }
    return (
        <>
            <Header />
            <PageHeading title="Delivery Status" />
            <div className='main-container'>
                <div className='delivery-status-wrapper'>
                    {/* <div className='delivery-wrapper'>
                        <div className='delivery-title'> Please share this OTP with Provider</div>
                        <div className='delivery-otp-wrap'>
                            <div className='otp-wrap'>
                                <div className='otp-title text-uppercase'>OTP</div>
                                <div className='otp-number'>{jobDetails?.otp}</div>
                            </div>
                        </div>
                    </div> */}
                    {/* <div className='delivery-wrapper'>
                        <div className='delivery-title'> Estimeted Delivery Time</div>
                        <div className='delivery-time-wrap'>
                            05:30 PM
                        </div>
                    </div> */}

                    <div className='track-order-wrapper'>
                        <div className='track-order-header'>
                            <div className='track-title'>Track Order</div>
                            <div className='track-id-number'>Order Id #{jobDetails?.jobId}</div>
                        </div>
                        <div className='track-step-wrapper'>
                            <div className={`${!details?.latestTrackingData?.otw ? 'fade track-step-wrap' : 'track-step-wrap'}`} >
                                <div className='track-step'>
                                    <div className='track-step-number'><span>1</span></div>
                                    <div className='track-line'></div>
                                </div>
                                <div className='track-step-message'>
                                    <div className='track-step-title'>On The Way</div>
                                    <div className='track-time-detail'>{formatDateTime(details?.latestTrackingData?.otw)}</div>
                                </div>
                            </div>
                            <div className={`${!details?.latestTrackingData?.inTransit ? 'fade track-step-wrap' : 'track-step-wrap'}`}>
                                <div className='track-step'>
                                    <div className='track-step-number'><span>2</span></div>
                                    <div className='track-line'></div>
                                </div>
                                <div className='track-step-message'>
                                    <div className='track-step-title'>Transit</div>
                                    <div className='track-time-detail'>{formatDateTime(details?.latestTrackingData?.inTransit)}</div>
                                </div>
                            </div>
                            <div className={`${!details?.latestTrackingData?.delivered ? 'fade track-step-wrap' : 'track-step-wrap'}`}>
                                <div className='track-step'>
                                    <div className='track-step-number'><span>3</span></div>
                                </div>
                                <div className='track-step-message'>
                                    <div className='track-step-title'>Delivered</div>
                                    <div className='track-time-detail'>{formatDateTime(details?.latestTrackingData?.delivered)}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        (origin && destination && details?.latestTrackingData?.otw) ?
                        <LiveTracking jobId={id} lastStatus={details?.latestTrackingStatus} startLocation={origin} endLocation={destination} />
                        : null
                    }



                    {/* <div className='w-100 d-flex gap-3 d-grid flex-column'>
                        <Button variant='outline-primary'>Add Review</Button>
                        <Button variant='primary'>Pay Now</Button>

                    </div> */}
                </div>
            </div>
            <Footer />


        </>
    )
}

export default JobStatus